// One place that records a good / not-good mark on a proposal, shared by the
// Inbox (in shadow mode) and the Runs page.
//
// A plain upsert, not an Edge Function: a mark has no side effects, and it lives
// in cm_proposal_grades precisely so cm_proposals keeps its no-admin-UPDATE
// guarantee. RLS pins graded_by to the caller, because the tally of these marks
// is what unlocks a wider mode.
import { supabaseClient } from '../../lib/supabaseClient'

export async function saveGrade(proposalId: string, grade: 'up' | 'down'): Promise<void> {
  const { data } = await supabaseClient.auth.getUser()
  const uid = data?.user?.id
  if (!uid) throw new Error('Not signed in')
  const { error } = await supabaseClient
    .from('cm_proposal_grades')
    .upsert({ proposal_id: proposalId, graded_by: uid, grade }, { onConflict: 'proposal_id,graded_by' })
  if (error) throw new Error(error.message)
}
